import React from 'react'
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { cartItem } from '../../features/cartdata'; 
import { useDispatch, useSelector} from 'react-redux' 
import { useSnackbar } from 'notistack';
import { Baseurl } from '../../constants/env';
import Button from 'react-bootstrap/esm/Button';

const ClearCartModal = (props) => {
    const [show, setShow] = useState(false);
    const dispatch = useDispatch();
    const{enqueueSnackbar} = useSnackbar();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
 const {userid} = useSelector((state)=>state.auth) 

  async function clearCart(){
      
    await  axios.delete(`${Baseurl}/clearcart?id=${userid}`,{ withCredentials: true })
    .then((resp) => {
     console.log(resp);
     props.setremove(resp);
     dispatch(cartItem(0));
     localStorage.setItem('cart',0)
     setShow(false) 
     enqueueSnackbar('Cart Is Cleared',{variant:'success'});
      
    }).catch((e)=>{
      console.log(e.mesaage);
    });
    }
    
  return (
    <>
    <button className="btn btn-outline-danger" disabled={props.loading}  onClick={handleShow} >
      Clear Cart
    </button>

    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false} style={{marginTop:'150px'}}
    >
      <Modal.Header closeButton className='bg-danger'>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body className='text-center bg-danger text-white'>
       Are You Sure ? 
      </Modal.Body>
      <Modal.Footer className='bg-danger'>
        <Button onClick={handleClose}>
          No
        </Button>
        <Button onClick={()=>{clearCart()}}>Yes</Button>
      </Modal.Footer>
    </Modal>
  </>
  )
}

export default ClearCartModal
